import { render, staticRenderFns } from "./PersianCalendar.vue?vue&type=template&id=755bb34a"
import script from "./PersianCalendar.vue?vue&type=script&lang=js"
export * from "./PersianCalendar.vue?vue&type=script&lang=js"
import style0 from "./PersianCalendar.vue?vue&type=style&index=0&id=755bb34a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports